import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "../../lib/utils";

const Loader = ({ paddingTop, text = "Loading..." }) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center w-full text-center",
        !paddingTop && "pt-40"
      )}
      style={paddingTop ? { paddingTop } : {}}
    >
      <Loader2 className="h-12 w-12 animate-spin text-primary mb-4" />
      <p className="text-muted-foreground font-medium text-base">
        {text}
      </p>
    </div>
  );
};

export default Loader;